module.exports = __webpack_public_path__ + "img/il.1243ac4.svg";